import React from "react"
import ExpenseList from "../../../../../Expenses/components/ExpensesList/Index/index"
function Presentation(props) {
  console.log(props)
  const { clientId, clientView } = props
  return <ExpenseList clientID={clientId} clientView={clientView} /> 
}

export default Presentation
